import React from 'react';
import PropTypes from 'prop-types';

const PopupCloseButtonMobile = ({ onClick }) => (
   <button className='legend-mobile-close-button' onClick={onClick}/>
);

PopupCloseButtonMobile.propTypes = {
   onClick: PropTypes.func
};

export default PopupCloseButtonMobile;
